/**
 * Generated from ch5_p03.fla
 */
export function ch5_p03(this: Ich5_p03) {
	const bg = this.bg;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const light = this.light;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_light.call(this.light);
	light.x = 689.25;
	light.y = 384;
	light.width = 1134.50;
	light.height = 768.00;
	light.alpha = 1.00;
	if (light.onLayout) light.onLayout();
	const holly = this.holly;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_holly.call(this.holly);
	holly.x = 487;
	holly.y = 768;
	holly.width = 489.00;
	holly.height = 665.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const frameRight = this.frameRight;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLlines.call(this.linesLeft);
	linesLeft.x = 1422.5;
	linesLeft.y = 384;
	linesLeft.width = 241.50;
	linesLeft.height = 768.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	const linesRight = this.linesRight;
	ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframerlines.call(this.linesRight);
	linesRight.x = 122.5;
	linesRight.y = 533.75;
	linesRight.width = 122.50;
	linesRight.height = 468.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_bg(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p03_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_light(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_light) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p03_light", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_holly(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp5_p03_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeRframe(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLframe(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLlines(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("Llines", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframerlines(this: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframerlines) {
	if (this.setLayoutTexture) this.setLayoutTexture("rlines", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich5_p03Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich5_p03Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich5_p03Sprite extends Ich5_p03Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich5_p03Text extends Ich5_p03Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich5_p03Polygon extends Array<number> {
}
interface Ich5_p03 {
	readonly bg: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_bg;
	readonly light: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_light;
	readonly holly: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_holly;
	readonly frameRight: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeRframe;
	readonly frameLeft: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLframe;
	readonly linesLeft: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLlines;
	readonly linesRight: Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframerlines;
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_bg extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_light extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_holly extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeRframe extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLframe extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframeLlines extends Ich5_p03Sprite {
}
interface Ich5_p03_hh_ch5_72dpi_p03psdAssetchp5_p03_wcframerlines extends Ich5_p03Sprite {
}
